import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  HostListener,
} from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { ChatService, Message } from "./chat.service";
import { Observable, Subscription } from "rxjs";
import { scan } from "rxjs/operators";
import { OwlOptions } from "ngx-owl-carousel-o";
import { ToggleService } from "./services/toggle.service";
import { RegistrationService } from "./services/registration.service";
import { LanguagesService } from "./services/languages.service";

declare var $: any;
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  testArr: { buttons: { link: string; text: string; page: string }[] } = {
    buttons: [
      {
        link: "https://cdn.pixabay.com/photo/2018/06/17/20/35/chain-3481377_1280.jpg",
        text: "test",
        page: "test",
      },
      {
        link: "https://cdn.pixabay.com/photo/2018/06/17/20/35/chain-3481377_1280.jpg",
        text: "test",
        page: "test",
      },

      {
        link: "https://cdn.pixabay.com/photo/2018/06/17/20/35/chain-3481377_1280.jpg",
        text: "test",
        page: "test",
      },
      {
        link: "https://cdn.pixabay.com/photo/2018/06/17/20/35/chain-3481377_1280.jpg",
        text: "test",
        page: "test",
      },
      {
        link: "https://cdn.pixabay.com/photo/2018/06/17/20/35/chain-3481377_1280.jpg",
        text: "test",
        page: "test",
      },
    ],
  };
  title = "Chatbot";
  bigRobot = true;
  showEmoj = true;
  userForm = {
    email: null,
    name: null,
    phone: null,
    clientId: null,
  };
  dateOfBirth;
  phone = "";
  name = "";
  email = "";
  clientId = "";
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    items: 2,
    dots: false,
    navSpeed: 700,
    navText: ["<", ">"],
    responsive: {
      992: {
        items: 1.5,
      },
      768: {
        items: 1.5,
      },
      400: {
        items: 1.5,
      },
      0: {
        items: 1.5,
      },
    },
    nav: true,
  };
  images = [
    {
      path: "https://i.picsum.photos/id/866/200/300.jpg?hmac=rcadCENKh4rD6MAp6V_ma-AyWv641M4iiOpe1RyFHeI",
    },
    {
      path: "https://i.picsum.photos/id/866/200/300.jpg?hmac=rcadCENKh4rD6MAp6V_ma-AyWv641M4iiOpe1RyFHeI",
    },
    {
      path: "https://i.picsum.photos/id/866/200/300.jpg?hmac=rcadCENKh4rD6MAp6V_ma-AyWv641M4iiOpe1RyFHeI",
    },
    {
      path: "https://i.picsum.photos/id/866/200/300.jpg?hmac=rcadCENKh4rD6MAp6V_ma-AyWv641M4iiOpe1RyFHeI",
    },
    {
      path: "https://i.picsum.photos/id/866/200/300.jpg?hmac=rcadCENKh4rD6MAp6V_ma-AyWv641M4iiOpe1RyFHeI",
    },
    {
      path: "https://i.picsum.photos/id/866/200/300.jpg?hmac=rcadCENKh4rD6MAp6V_ma-AyWv641M4iiOpe1RyFHeI",
    },
    {
      path: "https://i.picsum.photos/id/866/200/300.jpg?hmac=rcadCENKh4rD6MAp6V_ma-AyWv641M4iiOpe1RyFHeI",
    },
  ];
  showCarousal = false;
  scrollDown = false;
  currentBotMessageIndex = 0;
  starRatingModuleTriggerCount: number = 0;
  greet = "";
  subscription: Subscription = new Subscription();
  constructor(
    private chat: ChatService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private readonly toggleService: ToggleService,
    private registrationService: RegistrationService,
    private language: LanguagesService
  ) {}

  //@ViewChild("scrollElement", null) scroollProp: ElementRef;
  sessionId: any = new Date();
  uploadedFile: File;
  messages: Observable<Message[]>;
  formValue: string = "";
  lastMsg: any = {
    sessionAttributes: {},
    showInput: true,
    sessionDetails: {},
  };
  hasButtonBeenClicked = false;
  minDate = new Date();
  // minDate = moment(new Date()).format('YYYY-MM-DD')
  maxDate = new Date(2019, 12, 0);
  types: string[] = [];
  sessionAttrib: any = {};
  sessionDetails: any = {};
  userId: string = "user";
  showIndicator = false;
  uploadFile = File;
  userDetails = {};
  registerForm: FormGroup;
  submitted = false;
  count = 0;
  chatbot_lang = "en";
  sessionState: any = null;
  isRegFormSubmitted;

  //    isOnIOS:any = navigator.userAgent.match(/iPad/i)|| navigator.userAgent.match(/iPhone/i);
  //  eventName:any = this.isOnIOS ? "pagehide" : "beforeunload";

  @HostListener("window:beforeunload", ["$event"])
  async onBeforeUnload() {
     localStorage.setItem("sessionId", undefined);
     localStorage.setItem("chatbot_lang", undefined);
    localStorage.setItem("phone", undefined);
    localStorage.setItem("name", undefined);
    localStorage.setItem("email", undefined);
    localStorage.setItem("clientId", undefined);
    localStorage.setItem("dateOfBirth", undefined);
    window.localStorage.clear();
    // localStorage.clear();

  }
  @HostListener("window:pagehide", ["$event"])
  async pagehide() {
    localStorage.setItem("sessionId", undefined);
    localStorage.setItem("chatbot_lang", undefined);
    localStorage.setItem("phone", undefined);
    localStorage.setItem("name", undefined);
    localStorage.setItem("email", undefined);
    localStorage.setItem("clientId", undefined);
    localStorage.setItem("dateOfBirth", undefined);
    window.localStorage.clear();
    // localStorage.clear();
  }

  ngOnInit(): void {
    localStorage.setItem("sessionId", this.sessionId.getTime().toString());

    //! to check if the registrationform is submitted or not:
    this.registrationService._isRegFormSubmitted.subscribe((data) => {
      this.isRegFormSubmitted = data;
      console.log({ isRegFormSubmitted: this.isRegFormSubmitted });
      if (
        !this.isRegFormSubmitted &&
        this.registrationService.registrationForm
      ) {
        this.userDetails = this.registrationService.registrationForm;
        this.sendMessage(
          this.chatbot_lang == "en" ? "registerUser" : "registrarseUsuario",
          null,
          null,
          null,
          null,
          this.registrationService.registrationForm,
          true
        );
      }
    });

    setTimeout(() => {
      this.route.queryParams.subscribe((params) => {
        if (params.lang) {
          this.chatbot_lang = params.lang;
          localStorage.setItem("chatbot_lang", this.chatbot_lang);
        } else {
          if (localStorage.getItem("chatbot_lang") !== null) {
            this.chatbot_lang = localStorage.getItem("chatbot_lang");
          }
        }
        // localStorage.setItem("chatbot_lang", this.chatbot_lang);
      });

      if (this.chatbot_lang == "en") {
        this.sendMessage("Hello ", null, null, null, true);
      } else {
        this.sendMessage("Hola", null, null, null, true);
      }
    }, 1000);
    //! to send the form when the registration form is submitted:

    if (localStorage.getItem("phone")) {
      this.sessionId = localStorage.getItem("sessionId");
      console.log("sessionId reg", this.sessionId);
      this.sessionId = this.sessionId.toString();
      this.phone = localStorage.getItem("phone");
      this.name = localStorage.getItem("name");
      this.email = localStorage.getItem("email");
      this.clientId = localStorage.getItem("clientId");
      this.clientId = localStorage.getItem("dateOfBirth");

      this.userDetails = {
        phone: this.phone,
        name: this.name,
        email: this.email,
        sessionId: this.sessionId,
        clientId: this.clientId,
        dateOfBirth: this.dateOfBirth,
      };
    } else {
      //this.sessionId = (Math.floor(new Date().valueOf() * Math.random())).toString();
      localStorage.setItem("sessionId", this.sessionId.getTime().toString());
      console.log("sessionId reg", this.sessionId);
      localStorage.setItem("chatbot_lang", this.chatbot_lang);
      localStorage.setItem("phone", this.phone);
      localStorage.setItem("name", this.name);
      localStorage.setItem("email", this.email);
      localStorage.setItem("dateOfBirth", this.dateOfBirth);
    }

    // if (this.chatbot_lang == "en") {
    //   this.sendMessage("Hello ", null, null, null, false);
    // } else {
    //   this.sendMessage("Hola", null, null, null, false);
    // }
    $("#OpenImgUpload").click(function () {
      $("#imgupload").trigger("click");
    });

    this.sessionAttrib = {};
    this.chat.conversation
      .asObservable()
      .subscribe((data) => console.log(data));

    this.messages = this.chat.conversation.asObservable().pipe(
      scan((acc, val, i) => {
        console.log("acc", acc);
        console.log("val", val);
        let elementIndex = 0;
        for (let index = 0; index < acc.length; index++) {
          if (acc[index].sentBy === "bot" && acc[index].content) {
            elementIndex = index;
            break;
          }
        }
        let arr = [];
        if (val.length) {
          arr = val.concat(acc);
        } else {
          arr = val.concat([]);
        }

        for (let index = 0; index < arr.length; index++) {
          let nextIndex = index + 1;
          if (index !== arr.length - 1) {
            if (
              arr[nextIndex].content === "image" ||
              arr[nextIndex].content === "table"
            ) {
              nextIndex += 1;
            }
            if (
              (arr[index].sentBy === "user" &&
                arr[nextIndex].sentBy === "user") ||
              (arr[index].sentBy === "bot" && arr[nextIndex].sentBy === "bot")
            ) {
              arr[index]["showImage"] = false;
            } else {
              arr[index]["showImage"] = true;
            }
          } else {
            arr[index]["showImage"] = true;
          }
        }

        if (!this.formValue) {
          setTimeout(() => {
            const container = $("#content");
            const scrollTo = $(`#message_${elementIndex + 1}`);
            console.log(
              "test",
              container.offset(),
              "scroll to:",
              scrollTo.offset(),
              "container: ",
              container.scrollTop()
            );

            if (
              scrollTo &&
              container &&
              scrollTo.offset() &&
              container.offset()
            ) {
              console.log("scroll is working", this.formValue);
              container.animate({
                scrollTop:
                  scrollTo.offset().top -
                  container.offset().top +
                  container.scrollTop(),
              });
              console.log(
                "test2",
                container.offset().top,
                "scroll to:",
                scrollTo.offset().top,
                "container: ",
                container.scrollTop()
              );
            } else {
              container.animate({
                scrollTop: 129.265625 - 559.25,
              });
            }
          }, 1);
        }

        return arr;
      })
    );

    this.registerForm = this.formBuilder.group({
      firstName: ["", Validators.required],
      lastName: ["", Validators.required],
      email: ["", [Validators.required, Validators.email]],
    });
  }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.registerForm.invalid) {
      return;
    }
    this.sendMessage(
      "form " +
        this.f.firstName.value +
        " " +
        this.f.lastName.value +
        " " +
        this.f.email.value,
      null
    );
    // alert('SUCCESS!! :-)');
  }

  get f() {
    return this.registerForm.controls;
  }

  fireInputEvent() {
    $("input[type='file']").trigger("click");
  }

  sendImage(msg: any, image) {
    console.log(image.target.files);
    if (image.target.files && image.target.files[0]) {
      const file = image.target.files[0];
      let imageSrc = this;
      const reader = new FileReader();
      // @ts-ignore
      reader.readAsDataURL(file);
      reader.onload = function (fileLoaded) {
        console.log(reader.result);
        imageSrc.sendMessage("1", null, null, reader.result);
        return reader.result;
      };
    }
  }

  checkHelloString(str) {
    if (this.chatbot_lang == "es") {
      return str.replace(/Hola whatsapp:\+[0-9]+/i, "Hola");
    } else {
      return str.replace(/Hello whatsapp:\+[0-9]+/i, "Hello");
    }
  }

  sendMessage(
    msg: any = null,
    divId: string = null,
    slotToElicit: string = null,
    image: any = null,
    showMsg: boolean = null,
    sessionAttributes: any = null,
    form: boolean = false,
    msg_text?:string 
  ) {
    console.log(
      "this.registrationService.registrationForm",
      msg , msg_text
    );
    if (
      localStorage.getItem("phone") &&
      localStorage.getItem("phone") !== "" &&
      !form
    ) {
      this.phone = localStorage.getItem("phone");
      this.name = localStorage.getItem("name");
      this.email = localStorage.getItem("email");
      this.clientId = localStorage.getItem("clientId");

      this.userDetails = {
        phone: this.phone,
        name: this.name,
        email: this.email,
        clientId: this.clientId,
      };
    }
    this.bigRobot = false;
    this.currentBotMessageIndex = -1;
    console.log("msg: ", this.formValue);
    this.count++;
    if (msg) {
      this.formValue = msg;
    }

    if (this.sessionDetails) {
      slotToElicit = this.sessionDetails.slotToElicit;
    }

    if (this.formValue) {
      var regEx = /(^|\s)([0-9]{16}|[0-9]{13}|[0-9]{8})(\s|$)/;
      var regEx16 =
        /(^|\s)[0-9]{4}(-|\s)[0-9]{4}(-|\s)[0-9]{4}(-|\s)[0-9]{4}(\s|$)/;
      if (this.formValue.match(regEx)) {
        var str = this.formValue.match(regEx)[0];
        var regEx1 = /([0-9]{16}|[0-9]{13}|[0-9]{8})/;
        var str1 = str.match(regEx1)[0];
        // var star =
        //   str1.length == 8
        //     ? "********"
        //     : str1.length == 13
        //     ? "*************"
        //     : "****************";
        // str = str.replace(regEx1, star);
        this.formValue = this.formValue.replace(regEx, str);
      } else if (this.formValue.match(regEx16)) {
        var str = this.formValue.match(regEx16)[0];
        str = str.replace(/[0-9]/g, "*");
        this.formValue = this.formValue.replace(regEx16, str);
      }
      this.showIndicator = true;
      if (
        this.userForm.email != null &&
        this.userForm.name != null &&
        this.userForm.phone != null
      ) {
        this.sessionDetails.sessionAttributes.formValue = this.userForm;
        this.userForm = {
          email: null,
          name: null,
          phone: null,
          clientId: null,
        };
      }
      this.sessionAttrib = sessionAttributes;
      console.log("sessionId", this.sessionId);

      this.chat
        .converse(
          this.formValue,
          this.sessionId,
          this.sessionState,
          this.userDetails,
          this.sessionDetails,
          this.sessionAttrib,
          slotToElicit,
          image,
          showMsg,
          msg_text
        )
        .then((data) => {
          console.log("userInfo: ", data);

          console.log(data);
          this.sessionState = data.sessionState ? data.sessionState : null;
          this.showIndicator = false;
          this.lastMsg = data;
          this.sessionDetails = data.sessionDetails;
          this.types = [];
          if (data.sessionDetails) {
            this.sessionAttrib = data.sessionDetails.sessionAttributes;
            slotToElicit = data.sessionDetails.slotToElicit;
          }

          if (data.sessionState) {
            this.sessionAttrib = data.sessionState.sessionAttributes;
            slotToElicit = data.sessionState.dialogAction.slotToElicit;
          }
          if (data.userInfo) {
            this.userDetails = data.userInfo;
            localStorage.setItem(
              "phone",
              data.sessionState.intent.slots.phone.value.originalValue
            );
            this.registrationService.registrationForm.phoneNumber =
              data.userInfo.phoneNumber;
            localStorage.setItem("email", data.userInfo.email);
            localStorage.setItem("name", data.userInfo.name);
            localStorage.setItem("dateOfBirth", data.userInfo.dateOfBirth);
          } else {
            data.userInfo = this.userDetails;
          }
          this.lastMsg.showInput = true;
          this.lastMsg.timestamp = new Date().getTime();
          this.formValue = "";

          if (divId) {
            const el = document.getElementById(divId);
            const all = el ? el.getElementsByTagName("button") : null;
            if (all) {
              for (let i = 0; i < all.length; i++) {
                all[i].className += " btn-disabled";
                all[i].disabled = true;
              }
            }
          }
        });
    }
    this.formValue = "";
  }

  addEmoji(event) {
    if (!this.formValue) {
      this.formValue = "";
    }
    this.formValue = this.formValue + event.emoji.native;
    $("#text").val($("#text").val() + event.emoji.native);
    this.showEmoj = !this.showEmoj;
  }

  switchEmoj() {
    this.showEmoj = !this.showEmoj;
    if (this.showEmoj == true) {
      $(".float-icon").css("z-index", "99");
    } else {
      console.log("open it ");
      $(".float-icon").css("z-index", "0");
    }
  }

  closeMessage() {
    $(".welcome-message-toggle").hide();
  }

  clearMessages(): void {
    this.chat.conversation.next([]);
    this.starRatingModuleTriggerCount = 0;
    this.sendMessage("welcome message", null, null, null, true);
  }

  importFile(event) {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      let fileSrc = this;
      this.sendMessage;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function (fileLoaded: any) {
        console.log(fileLoaded.srcElement.result.substring(5, 15));
        const fileType: string = fileLoaded.srcElement.result.substring(5, 15);
        if (fileType.includes("image")) {
          fileSrc.sendMessage("1", null, null, reader.result);
        } else {
          fileSrc.sendMessage(
            `${file.name} file Uploded Successully`,
            null,
            null,
            null,
            null
          );
        }
        return reader.result;
      };
    }
  }

  triggerRatingModuleFrom(component) {
    if (
      component == "header-component" &&
      this.starRatingModuleTriggerCount > 0
    ) {
      // if(){
      this.clearMessages();
      this.toggleService.toggleChatbot(2);
      // }
    } else {
      this.starRatingModuleTriggerCount =
        +this.starRatingModuleTriggerCount + 1;
    }
  }

  getData(data) {
    console.log(data);
  }
}
